import React__default from 'react';
import { motion } from 'framer-motion';

const ListItemWrapper = ({ children  })=>/*#__PURE__*/ React__default.createElement(motion.li, {
        variants: {
            start: {
                opacity: 0
            },
            end: {
                opacity: 1
            }
        },
        className: "recommendation-list__list-item"
    }, children)
;

export { ListItemWrapper };
//# sourceMappingURL=ListItemWrapper.js.map
